import type { SessionUser } from '@shared/types';

export interface PartnerLink {
  to: string;
  /** Short, for header buttons and menus. */
  label: string;
  /** Spoken form for the account card. */
  long: string;
  kind: 'reseller' | 'creator';
}

/**
 * Where an active partner's tools live, one link per role. A reseller gets the
 * partner dashboard, a creator (streamer) the creator page of it; an account
 * that is both gets both. The header, its menus and the account page all show
 * the same links so a partner never has to hunt for them.
 */
export function partnerLinks(user: Pick<SessionUser, 'partner'> | null | undefined): PartnerLink[] {
  const p = user?.partner;
  if (!p || p.status !== 'active') return [];
  const out: PartnerLink[] = [];
  if (p.types.includes('reseller')) out.push({ to: '/partner', label: 'Partner dashboard', long: 'Go to your partner dashboard', kind: 'reseller' });
  if (p.types.includes('creator')) out.push({ to: '/partner/creator', label: 'Streamer dashboard', long: 'Go to your streamer dashboard', kind: 'creator' });
  return out;
}
